<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >物流&订单管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/outboundIndex/outboundList' }"
          >出库管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>订单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <!-- <h1>商品基础信息设置</h1> -->
      <div class="content_wrap flex-rowl">
        <div class="tip_wrap">
          <div class="item">
            <h1>订单编号：</h1>
            <p>{{ dataItem.orderno }}</p>
          </div>
          <div class="item">
            <h1>订单类型：</h1>
            <p>{{ dataItem.ordertypestr }}</p>
          </div>
          <div class="item">
            <div
              class="block"
              v-for="(item, index) in orderShopList"
              :key="index"
            >
              <h1>
                商品名称：<span>{{ item.cmname }}</span>
              </h1>
              <div class="txt">
                <p v-for="(label, labelIndex) in item.attr" :key="labelIndex">
                  {{ label }}
                </p>
              </div>
              <h1>
                商品数量：<span>{{ item.cmnum }}</span>
              </h1>
              <div class="warehouse flex-rowl">
                <h1>库源信息：</h1>
                <p v-html="item.msg"></p>
              </div>
              <div class="backLog_wrap" v-if="item.backlog.id">
                <h1>
                  退款申请工单序号：<span>{{
                    item.backlog.transaction_id
                  }}</span>
                </h1>
                <h1>
                  退款类型：<span>{{ item.backlog.logtypestr }}</span>
                </h1>
                <h1>
                  退款金额：<span>¥ {{ item.backlog.fee }}</span>
                </h1>
                <h1>
                  退款情况：<span>{{ item.backlog.returnnotestr }}</span>
                </h1>
                <h1>
                  退费原因：<span>{{ item.backlog.reasonidstr }}</span>
                </h1>
                <h1>
                  退款状态：<span>{{ item.backlog.returnstate }}</span>
                </h1>
                <h1>
                  退款审核状态：<span>{{ item.backlog.checkstatestr }}</span>
                </h1>
                <h1>
                  退款属性：<span>{{ item.backlog.returnattrstr }}</span>
                </h1>
                <h1>
                  退款时间：<span>{{
                    item.backlog.returndate | formatDate
                  }}</span>
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div class="tip_wrap">
          <div class="item">
            <h1>收件人：</h1>
            <p>
              {{ dataItem.truename }}
              <span
                class="copy_box"
                :data-clipboard-text="dataItem.truename"
                @click="handleCopyBtn"
                ><i class="iconfont icon-fuzhi"></i
              ></span>
            </p>
          </div>
          <div class="item">
            <h1>收件人联系方式：</h1>
            <p>
              {{ dataItem.cellphone }}
              <span
                class="copy_box"
                :data-clipboard-text="dataItem.cellphone"
                @click="handleCopyBtn"
                ><i class="iconfont icon-fuzhi"></i
              ></span>
            </p>
          </div>
          <div class="item">
            <h1>物流信息：</h1>
            <p>
              {{ dataItem.order_addr }}
              <span
                class="copy_box"
                :data-clipboard-text="dataItem.order_addr"
                @click="handleCopyBtn"
                ><i class="iconfont icon-fuzhi"></i
              ></span>
            </p>
          </div>
          <div class="item">
            <h1>订单状态：</h1>
            <p>{{ dataItem.orderstate }}</p>
          </div>
          <!-- <div class="item">
            <h1>订单情况：</h1>
            <p>{{ dataItem.order_addr }}</p>
          </div> -->
          <div class="item">
            <h1>物流类型：</h1>
            <p>{{ dataItem.service_company }}</p>
          </div>
          <div class="item">
            <h1>发货物流订单号：</h1>
            <p>{{ dataItem.service_no }}</p>
          </div>
          <div class="item">
            <h1>发货门店：</h1>
            <p>{{ dataItem.service_shopstr }}</p>
          </div>
        </div>
        <div class="tip_wrap">
          <div class="item">
            <h1>订单物流状态：</h1>
            <p>{{ dataItem.service_state }}</p>
          </div>
          <div class="item">
            <h1>用户是否验收：</h1>
            <p>{{ dataItem.isrec == 0 ? "未收货" : "已收货" }}</p>
          </div>

          <!-- <div class="item">
            <h1>库源信息：</h1>
            <p v-html="dataItem.warehouse"></p>
          </div> -->
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" :class="isNoSend ? 'disable' : ''" @click="handleGo(1)">
        配货
      </div>
      <div class="btn" :class="isNoSend ? 'disable' : ''" @click="handleGo(2)">
        发货
      </div>
      <!-- <div
        class="btn"
        :class="dataItem.service_state == '已发货' || (dataItem.service_state == '待发货' && shopBacklog && shopBacklog.checkstate != 5) || (dataItem.service_state == '待发货' && shopBacklog && shopBacklog.checkstate != 6) ? 'disable' : ''"
        @click="handleGo(2)"
      >
        发货
      </div> -->
      <!-- <div class="btn" @click="handleGo(3)">退货处理</div> -->
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>

<script>
import Clipboard from "clipboard";
import { encryptstringview, encryptstringadd } from "../../api/api";
import { getLogisticsDetail, getLogisticsDisList } from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "outboundDetail",
  data() {
    return {
      loading: false,
      id: "",
      dataItem: "",

      orderShopList: "", // 订单商品列表
      shopBacklog: "",
      isNoSend: false,

      orderShopParams: {
        wsid: "",
        pageindex: 1,
        pagesize: 50,
      },
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id;
        this.orderShopParams.wsid = id;
        this.init(id);
      } else {
        this.$router.back();
      }
    },

    async init(id) {
      this.loading = true;
      // 订单数据
      let res1 = await getLogisticsDetail({ id });
      this.dataItem = res1;
      this.shopBacklog = res1.backlog.length > 0 ? res1.backlog[0] : "";
      if (this.dataItem.service_state == "已发货") {
        this.isNoSend = true;
      } else if (
        this.shopBacklog &&
        this.shopBacklog.checkstate != 5 &&
        this.shopBacklog.checkstate != 6
      ) {
        this.isNoSend = true;
      }
      // 订单商品
      let res2 = await getLogisticsDisList(this.orderShopParams);
      if (res2.list.length > 0) {
        res2.list.forEach((v) => {
          v.msg = v.msg != "" ? v.msg.replace(/\|/g, "<br/>") : "";
          v.attr = v.attr && v.attr != "" ? JSON.parse(v.attr) : [];
          v.backlog =
            v.ams_shop_backlog.length > 0 ? v.ams_shop_backlog[0] : "";
        });
      }
      this.orderShopList = res2.list;

      this.loading = false;
    },
    // 订单列表
    // getLogisticsDetail(id) {
    //   this.loading = true;
    //   getLogisticsDetail({ id }).then((res) => {
    //     if (res.order_goods != "" && res.order_goods) {
    //       let parsedData;
    //       try {
    //         parsedData = JSON.parse(res.order_goods);
    //       } catch (error) {
    //         // 在转换失败时提供默认值
    //         parsedData = res.order_goods;
    //       }
    //       parsedData.forEach((v) => {
    //         console.log(v,'====vvv');
    //         v.attr = v.attr != "" ? JSON.parse(v.attr) : "";
    //       });
    //       res.order_goods = parsedData;
    //     }

    //     this.dataItem = res;
    //     this.loading = false;
    //   });
    // },

    handleReturn() {
      this.$router.back();
    },

    // 跳转页面
    handleGo(type) {
      let { id, dataItem, isNoSend } = this;
      // if (type == 1) {
      if (type == 1 && dataItem.service_state != "已发货" && !isNoSend) {
        this.encryptstringadd("outboundDistributionList", { wsid: id });
        // this.$router.push(`/outboundIndex/outboundDistributionList/${id}`);
      } else if (type == 2 && dataItem.service_state != "已发货" && !isNoSend) {
        // this.$router.push(`/outboundIndex/outboundEdit/${id}`);
        this.encryptstringadd("outboundEdit", { id });
        // this.$router.push({ name: "outboundEdit", params: { id } });
      } else if (type == 3) {
        this.$message.warning("即将开放");
      }
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$message.warning("复制失败");
        } else {
          // this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 18px;
          color: #6e6e6e;
          .block {
            margin-bottom: 20px;
          }
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
            span {
              color: #6e6e6e;
              font-size: 16px;
            }
          }
          p {
            font-size: 16px;
          }
          .copy_box {
            cursor: pointer;
            // margin-left: 10px;
            .iconfont {
              font-size: 20px;
            }
          }
        }
        .warehouse {
          align-items: flex-start;
          h1 {
            white-space: nowrap;
            line-height: 20px;
          }
          p {
            line-height: 20px;
          }
        }
        .backLog_wrap {
          h1 {
            font-size: 14px;
            span {
              font-size: 12px;
            }
          }
          p {
            font-size: 12px;
          }
        }
      }
    }
  }
  .form_footer {
    .btn {
      &:nth-child(2) {
        margin: 0 30px;
      }
      &.disable {
        background: #a6a6a6;
      }
    }
  }
}
</style>